import type { ControlSetupContext } from './helpers';

export function setupActionControls(ctx: ControlSetupContext): void {
  const { controls: ui } = ctx;

  ui.bindButton('zoomOutBtn', () => ctx.zoomController.zoomOut());
  ui.bindButton('resetBtn', () => {
    ctx.zoomController.reset();
  });
}
